import { Banner } from 'components/Banner/Banner'
import { useBankAccountDetailsContext } from './Providers/BankAccountDetailsContextProvider'
import {
  BANK_ACCOUNT_DETAILS_BANNER_OTHER,
  BANK_ACCOUNT_DETAILS_BANNER_TEXT,
  BANK_ACCOUNT_DETAILS_STATUS_REASONS
} from './constants'
import { BANK_ACCOUNT_STATUS } from '../BankAccountsTable/constants'

export const BankAccountDetailsBanner = () => {
  const {
    state: { details }
  } = useBankAccountDetailsContext()

  if (
    details?.status_reason === BANK_ACCOUNT_DETAILS_STATUS_REASONS.ADMIN_ACTION
  )
    return (
      <Banner.Error
        className="mb-32"
        {...BANK_ACCOUNT_DETAILS_BANNER_OTHER.BANK_ACCOUNT_DETAILS_STATUS_REASONS_ADMIN_ACTION}
      />
    )

  if (details?.status_reason === BANK_ACCOUNT_DETAILS_STATUS_REASONS.OTHER)
    return (
      <Banner.Error
        className="mb-32"
        {...BANK_ACCOUNT_DETAILS_BANNER_OTHER.BANK_ACCOUNT_DETAILS_STATUS_REASONS_OTHER}
      />
    )

  switch (details?.status) {
    case BANK_ACCOUNT_STATUS.CREATED:
      return (
        <Banner.Info
          className="mb-32"
          {...BANK_ACCOUNT_DETAILS_BANNER_OTHER.BANK_ACCOUNT_DETAILS_STATUS_CREATED}
        />
      )
      break
    case BANK_ACCOUNT_STATUS.PENDING:
      return (
        <Banner.Info
          className="mb-32"
          subtext={
            <>
              Two small deposits have been sent to your{' '}
              <span className="semibold">{details?.bank_name}</span> account
              ending in{' '}
              <span className="semibold">{details?.account_number}</span> Check
              your transaction history in{' '}
              <span className="semibold">3–5 business days</span>, the deposits
              will appear as two separate entries, each under $1.00. Once you
              see them, return here and click{' '}
              <span className="semibold">Verify Deposits</span> to complete the
              verification.
            </>
          }
          text="Micro-deposits sent, please wait before verifying."
        />
      )
      break
    case BANK_ACCOUNT_STATUS.VERIFICATION_FAILED:
    case BANK_ACCOUNT_STATUS.ERRORED: {
      if (
        details.status_reason &&
        BANK_ACCOUNT_DETAILS_BANNER_TEXT[details.status]?.[
          details.status_reason
        ]
      ) {
        const { text, subtext } =
          BANK_ACCOUNT_DETAILS_BANNER_TEXT[details.status]?.[
            details.status_reason
          ]
        return <Banner.Error className="mb-32" text={text} subtext={subtext} />
      }
      return null
      break
    }
    default:
      return null
  }
}
